export default __webpack_public_path__ + "static/media/MeterGroupListPlaceholder.dd0ae6f3.png";